import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PackingStationsApiAdapter } from '../adapters/PackingStationsApiAdapter';
import { Service } from '../services/Service';

export const useTogglePackingStationStatus = () => {
  const { t } = useTranslation('packingStationsModule');
  const { toast } = useToast();
  const [isToggling, setIsToggling] = useState(false);

  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PackingStationsApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const toggleStatus = async (id: number, currentActive: boolean, onSuccess?: () => void) => {
    setIsToggling(true);

    try {
      console.log('🔍 useTogglePackingStationStatus - Cambiando estado:', { id, currentActive });

      await service.toggleStatus(id, !currentActive);

      console.log('🔍 useTogglePackingStationStatus - Estado cambiado correctamente');

      toast({
        title: t('toasts.toggleStatus.success.title'),
        description: t('toasts.toggleStatus.success.description'),
        variant: 'default',
      });

      onSuccess?.();
    } catch (error: any) {
      console.log('🔍 useTogglePackingStationStatus - Error:', {
        message: error.message,
        response: error.response,
      });

      toast({
        title: t('toasts.toggleStatus.error.title'),
        description: error.response?.data?.message || t('toasts.toggleStatus.error.description'),
        variant: 'destructive',
      });
    } finally {
      setIsToggling(false);
    }
  };

  return { toggleStatus, isToggling };
};
